/**
 * Global configuration defaults and runtime config management.
 */

import type { CoignConfig } from './types.js';

export const DEFAULT_PROMPT =
  'You are a helpful page assistant. Answer using the page context when relevant. Be concise.';

export const DEFAULT_CONFIG: Partial<CoignConfig> = {
  preset: 'coign-lite',
  model: 'coign-lite',
  quick: true,
  quickPreset: 'coign-quick',
  engage: 'ask',
  engineMode: 'worker',
  widget: true,
  stream: true,
  prompt: DEFAULT_PROMPT,
  selectDOM: 'main, [role="main"], article',
  position: 'bottom-right',
  autoApprove: ['read'],
  persistHistory: true,
  cacheBackend: 'cache',
  toolTimeoutMs: 5000,
} as const;

let _globalConfig: Partial<CoignConfig> = {};

export function getConfig(): Readonly<Partial<CoignConfig>> {
  return Object.freeze({ ...DEFAULT_CONFIG, ..._globalConfig });
}

export function patchConfig(patch: Partial<CoignConfig>): void {
  _globalConfig = { ..._globalConfig, ...patch };
}

export function resetConfig(): void {
  _globalConfig = {};
}
